<template>
  <ValidationProvider
    v-slot="{ errors, invalid, validated }"
    :name="label"
    :rules="rules"
    tag="div"
  >
    <b-field
      :custom-class="labelClass"
      :label="label"
      :label-for="name"
      :type="getMessage(validated, invalid, errors) ? 'is-danger' : ''"
      :message="getMessage(validated, invalid, errors)"
    >
      <b-select v-if="type === 'state'" :id="name" v-model="currentValue">
        <option v-for="state in states" :key="state.code" :value="state.code">
          {{ state.name }}
        </option>
      </b-select>

      <b-input
        v-else
        :id="name"
        v-model="currentValue"
        :custom-class="inputClass"
      ></b-input>
    </b-field>
  </ValidationProvider>
</template>

<script>
import { US_STATES } from '@/components/onboarding/constants'

export default {
  props: {
    inputClass: {
      default: '',
      required: false,
      type: String,
    },
    labelClass: {
      default: '',
      required: false,
      type: String,
    },
    name: {
      required: true,
      type: String,
    },
    label: {
      required: true,
      type: String,
    },
    rules: {
      default: '',
      required: false,
      type: [Object, String],
    },
    type: {
      default: () => undefined,
      required: false,
      type: String,
    },
    value: {
      required: true,
    },
  },
  computed: {
    currentValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    states() {
      return US_STATES
    },
  },
  methods: {
    getMessage(validated, invalid, errors) {
      if (this.overrideMessage) return this.overrideMessage

      if (validated && invalid && errors.length > 0) return errors[0]
    },
  },
}
</script>
